
import React from "react";
import { useSelector } from "react-redux";
import SRList from "../component/List";
import Moment from "react-moment";
import AkkhorLayout from "../layout/Akkhor";

export default function ListChuongTrinhHoc() {
  let params = '';
  const columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "title", label: "Tên chương trình", options: { filter: true, sort: true } },
    {
      name: "datecreate", label: "Ngày tạo",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const time = new Date(value * 1000);
          return <Moment format="HH:mm DD/MM/YYYY">{time}</Moment>;
        },
      }
    }
  ];


  return (
    <AkkhorLayout idrole="list-books">
      <SRList name="books" idrole="list-books" params={params} title="Chương trình học" defaultLimit={50} serverSide={true} columns={columns}></SRList>
    </AkkhorLayout>
  );
}
